var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',{attrs:{"api-key":null,"init":_vm.editorConfig,"disabled":_vm.disabled},on:{"input":_vm.handleChangeContent},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }